import axios from "axios";

import {
  SUMMARY_ATTEMPT,
  SUMMARY__SUCCESS,
  SUMMARY_FAILED,
} from "../types/summaryByUserTypes";
import { config } from "../../config";
const url_api = config.api.godiway;

export function loading() {
  return {
    type: SUMMARY_ATTEMPT,
  };
}

export function success(item) {
  return {
    type: SUMMARY__SUCCESS,
    item: item,
  };
}

export function failed(error) {
  return {
    type: SUMMARY_FAILED,
    error: error,
  };
}

export const loadList = (data: Object) => async (dispatch) => {
  dispatch(loading());
  await axios
    .get(url_api + "summary/user", {
      params: {
        id: data.user_id,
      },
      headers: { Authorization: `Bearer ${data.token}` },
    })
    .then(function (response) {
      // console.log(response);
      if (response.status < 300) {
        if (response.data.status === "Success")
          dispatch(success(response.data.body));
        else dispatch(failed(response.data.body));
      } else {
        dispatch(failed("try_later"));
      }
    })
    .catch(function (error) {
      console.log(error);
      if (error.Error) {
        dispatch(failed("try_later"));
      } else {
        dispatch(failed("try_later"));
      }
      return;
    });
};
